import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NoteAlt } from '@mui/icons-material';
import { Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { RichTextbox } from '../richtext/index.js';
export function NotesSection(props) {
    const { character, canEdit = false } = props;
    const handleNotesChange = React.useCallback((value) => {
        character.dmNotes = value || undefined;
    }, [character]);
    return (_jsxs(Paper, { component: "section", variant: "outlined", sx: { p: 3 }, children: [_jsxs(Stack, { direction: "row", spacing: 1, alignItems: "center", sx: { mb: 2 }, children: [_jsx(NoteAlt, { color: "secondary" }), _jsx(Typography, { variant: "h6", component: "h2", children: "DM Notes" })] }), _jsx(RichTextbox, { contentId: `${character.id}-dmNotes`, content: character.dmNotes ?? '', onChange: handleNotesChange, canEdit: canEdit, placeholder: "No DM notes." })] }));
}
//# sourceMappingURL=NotesSection.js.map